import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetContractIdentifiersQuery from '@/graphql/contracts/getContractIdentifiers.query.gql';

import { notificationService } from '@/services/notification/notification.client';
import { ContractIdentifiers, ContractIdentifiersVariables } from
  '@/graphql/contracts/_generated_/getContractIdentifiers.query';
import { ContractIdentifiersInputType } from '@/graphql/contracts/_generated_/contracts';


export default function useGetContractIdentifiers() {
  const [_getContractIdentifiers, { loading, error }] = useLazyQuery<ContractIdentifiers,
  ContractIdentifiersVariables>(
    GetContractIdentifiersQuery,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      fetchPolicy: 'network-only'
    }
  );

  const getContractIdentifiers = async (input: ContractIdentifiersInputType[]) => {
    const result = await _getContractIdentifiers({
      variables: {
        input,
      },
    });

    return result.data?.contractIdentifiers;
  };

  return {
    getContractIdentifiers,
    isLoadingGetContractIdentifiers: loading,
    error
  };
}
